<template>
  <div id="navigation">
    <nav class="navbar navbar-expand-lg fixed-top center-brand static-nav">
      <div class="container">
        <a class="navbar-brand" href="#">
          <img src="..\assets\img\ISC logo.png" alt="logo" class="logo-default" />
        </a>
        <button
          class="navbar-toggler navbar-toggler-right collapsed"
          type="button"
          data-toggle="collapse"
          data-target="#xenav"
        >
          <i class="fas fa-bars fa-2x"></i>
        </button>
        <div class="collapse navbar-collapse" id="xenav">
          <ul class="navbar-nav" id="container">
            <li class="nav-item">
              <a class="nav-link active" href="#about">{{ $t('nav.about') }}</a>
            </li>
            <li class="nav-item">
              <a class="nav-link" href="#news">{{ $t('nav.news') }}</a>
            </li>
            <li class="nav-item">
              <a href="#" class="nav-link">
                {{ $t('nav.service') }}
                <i class="fas fa-caret-down"></i>
              </a>
              <ul class="dropdown">
                <li class="nav-item">
                  <a class="nav-link" href="#company_services">{{ $t('nav.company') }}</a>
                </li>
                <li class="drop-down">
                  <a href="#" class="nav-link">
                    {{ $t('nav.home') }}
                    <i class="fas fa-caret-down"></i>
                  </a>
                  <ul>
                    <li class="nav-item">
                      <a class="nav-link" href="#internet">{{ $t('nav.subMenu.internet') }}</a>
                    </li>
                    <li class="nav-item">
                      <a class="nav-link" href="#telePhone">{{ $t('nav.subMenu.telePhone') }}</a>
                    </li>
                    <li class="nav-item">
                      <a class="nav-link" href="#package">{{ $t('nav.subMenu.package') }}</a>
                    </li>
                    <li class="nav-item">
                      <a class="nav-link" href="#tv">{{ $t('nav.subMenu.tv') }}</a>
                    </li>
                  </ul>
                </li>
              </ul>
            </li>
          </ul>
          <ul class="navbar-nav ml-auto">
            <li class="nav-item">
              <a class="nav-link" href="#event">{{ $t('nav.event') }}</a>
            </li>
            <li class="nav-item">
              <a class="nav-link" href="#contact">{{ $t('nav.contanct') }}</a>
            </li>
            <li class="nav-item">
              <a class="nav-link" @click="openLogin()">{{ $t('nav.login') }}</a>
            </li>
            <li class="nav-item">
              <img
                v-if="lang == 'en'"
                class="nav-img"
                id="btnEn"
                @click="setLocale('mn')"
                src="../assets/img/icon/en.png"
                aria-placeholder="english"
                alt="English"
              />
              <img
                v-if="lang == 'mn'"
                class="nav-img"
                id="btnMn"
                @click="setLocale('en')"
                src="../assets/img/icon/mn.png"
                alt="Mongolia"
              />
            </li>
          </ul>
        </div>
      </div>
    </nav>
  </div>
</template>

<style scoped>

.navbar.navbar-expand-lg .nav-item a:hover {
    color: #ffffff;
}

.navbar-light .navbar-brand {
    padding-top: 10px;
}

.navbar .nav-item a {
    color: #ffffff;
    font-size: 14px;
    font-family: 'Montserrat', sans-serif;
    font-weight: 400;
    text-transform: capitalize;
}
ul li {
  display: inline-block;
  position: relative;
  line-height: 21px;
  text-align: left;
}
ul li a:hover {
  background: rgb(165, 35, 59);
  opacity: 0.9;
}
ul li ul.dropdown {
  min-width: 100%; /* Set width of the dropdown */
  display: none;
  position: absolute;
  z-index: 999;
  left: 0;
}
ul li:hover ul.dropdown {
  display: block; /* Display the dropdown */
}
ul li ul.dropdown li {
  display: block;
}
.drop-down ul {
  display: block;
  position: absolute;
  left: 0;
  top: calc(100% + 30px);
  z-index: 99;
  opacity: 0;
  visibility: hidden;
  padding: 10px 0;
  transition: 0.3s;
}

.drop-down:hover > ul {
  opacity: 1;
  top: 100%;
  visibility: visible;
}

.drop-down li {
  min-width: 180px;
  position: relative;
}

.drop-down ul a {
  padding: 10px 20px;
  font-size: 14px;
  font-weight: 500;
  text-transform: none;
  color: #ffff;
}

.drop-down ul {
  top: 0;
  left: calc(100% - 30px);
}

.drop-down:hover > ul {
  opacity: 1;
  top: 0;
  left: 100%;
}

.drop-down > a {
  padding-right: 35px;
}


@media (max-width: 1366px) {
  .drop-down ul {
    left: -90%;
  }
  .drop-down:hover > ul {
    left: -100%;
  }
}
</style>

<script>

export default {
  data() {
    return {
      lang: "mn"
    };
  },
  methods: {
    setLocale: function(locale) {
      this.lang = locale;
      this.$i18n.locale = locale;
      this.$i18n.fallbackLocale = locale;
    },
    openLogin(){
      this.$router.push('login');
    }
  }
};
</script>

